'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _configs = require('../../helpers/configs');

var _eachSeries = require('async/eachSeries');

var _eachSeries2 = _interopRequireDefault(_eachSeries);

var _getCheckoutUrl = require('../../services/shopify/getCheckoutUrl');

var _getCheckoutUrl2 = _interopRequireDefault(_getCheckoutUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
State
---
Root state object that holds the global state for the site.
----------------------------*/

var state = {
  cartItems: [],
  miniCartIsOpen: false,
  checkoutUrl: window.theme.shopifySecureUrl + '/checkout'
};

/*----------------------------
Mutations
---
Operations that are responsible for mutating the state.
Each mutation handler gets the entire state tree as the
first argument, followed by additional payload arguments.
Mutations must be synchronous and can be recorded by plugins for debugging purposes.
----------------------------*/

var mutations = {
  /**
   * Set Cart Items
   *
   * @param   array   newCartItems - Array of cart items. Should be passed in the same format as returned from the Shopify api.
   */

  setCartItems: function setCartItems(state, newCartItems) {
    state.cartItems = newCartItems;
  },


  /**
   * Toggle Mini Cart
   */

  toggleMiniCart: function toggleMiniCart(state) {
    state.miniCartIsOpen = !state.miniCartIsOpen;
  },


  /**
   * Set Checkout URL
   *
   * @param   string   updatedCheckoutUrl - New checkout URL.
   */

  setCheckoutUrl: function setCheckoutUrl(state, updatedCheckoutUrl) {
    state.checkoutUrl = updatedCheckoutUrl;
  }
};

/*----------------------------
Actions
---
Functions that cause side effects and can involve asynchronous operations.
Actions are normally responsible for committing mutations.
----------------------------*/

var actions = {
  /**
   * Hydrate Cart Items
   */

  hydrateCartItems: function hydrateCartItems(_ref) {
    var commit = _ref.commit;

    return new Promise(function (resolve, reject) {
      // Refresh the list of items in a users cart from the Shopify api.

      _axios2.default.get('/cart.js').then(function (response) {
        var cartData = response.data;
        // Set the cart items in store.
        var cartItems = cartData.items;
        commit('setCartItems', cartItems);
        resolve();
      });

      // Get Checkout URL

      (0, _getCheckoutUrl2.default)().then(function (checkoutUrl) {
        commit('setCheckoutUrl', checkoutUrl);
      });
    });
  },


  /**
   * Remove Cart Item
   *
   * @param   int   itemKey - The unique line item key.
   */

  removeCartItem: function removeCartItem(_ref2, lineItemKey) {
    var dispatch = _ref2.dispatch,
        commit = _ref2.commit;

    return new Promise(function (resolve, reject) {
      _axios2.default.post('/cart/change.js', {
        id: lineItemKey,
        quantity: 0
      }, _configs.axiosShopifyPostConfig).then(function (response) {
        dispatch('hydrateCartItems');
        resolve();
      });
    });
  },


  /**
   * Add Cart Items
   *
   * @param   array   cartItems - Pass the quantity and variant id for each product we want to add to cart. { id: '', quantity: ''}.
   */

  addCartItems: function addCartItems(_ref3, cartItems) {
    var dispatch = _ref3.dispatch,
        commit = _ref3.commit;

    return new Promise(function (resolve, reject) {
      _axios2.default.post('/cart/add.js', { items: cartItems }, _configs.axiosShopifyPostConfig).then(function (response) {
        dispatch('hydrateCartItems');
        resolve();
      }).catch(function (error) {
        // Could not add product to cart. Likely because no more product in stock.
        reject(error.response.data.description);
      });
    });
  },


  /**
   * Change Cart Item
   *
   * @param   object   productData - Pass the line item id and quantity of the product in a single object. {line: number, quantity: Number}
   */

  changeCartItem: function changeCartItem(_ref4, productData) {
    var dispatch = _ref4.dispatch,
        commit = _ref4.commit;

    return new Promise(function (resolve, reject) {
      _axios2.default.post('/cart/change.js', productData, _configs.axiosShopifyPostConfig).then(function (response) {
        dispatch('hydrateCartItems').then(function () {
          resolve();
        });
      }).catch(function (error) {
        // Could not add product to cart. Likely because no more product in stock.
        reject(error.response.data.description);
      });
    });
  },


  /**
   * Toggle Mini Cart
   */

  toggleMiniCart: function toggleMiniCart(_ref5) {
    var commit = _ref5.commit;

    commit('toggleMiniCart');
  }
};

/*----------------------------
Getters
---
Functions that can grab, alter and return data from state.
These are reactive. When the state changes these values will change.
----------------------------*/

var getters = {
  /**
   * Cart Subtotal
   */

  cartSubtotal: function cartSubtotal(state) {
    // Save each items total price (unit x quantity) in an array. Then reduce the array down to get the total price.
    // Price will be returned in cents. Need to use a money formatter to adjust in the liquid template.

    return state.cartItems.map(function (item) {
      return item.price * item.quantity;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  },


  /**
   * Cart Count
   */

  cartCount: function cartCount(state) {
    // Save each items quantity in an array. Then reduce the array down to get the total quantity.
    return state.cartItems.map(function (item) {
      return item.quantity;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  },


  /**
   * Cart Subscription Item
   */

  cartSubscriptionItem: function cartSubscriptionItem(state) {
    return state.cartItems.find(function (item) {
      return item.sku === 'ANYA-SUBSCRIPTION';
    });
  }
};

/*----------------------------
Cart Vuex Data
---
Export state, getters, actions and mutations so they can be used by vue instances and components.
----------------------------*/

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};